import React from 'react';

interface ChamferedRectIconProps extends React.SVGProps<SVGSVGElement> {
  /** Сторона квадрата иконки, как `size` у lucide-react. */
  size?: number;
}

/** Прямоугольник со срезанными углами в стиле lucide-react (сетка 24, обводка `currentColor`) — в lucide такой нет. */
function ChamferedRectIcon(props: ChamferedRectIconProps) {
  const { size = 24, strokeWidth = 2, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M6 5h12l4 4v6l-4 4H6l-4-4V9z" />
    </svg>
  );
}

export default ChamferedRectIcon;
